import React, { Component } from "react";
import { OverlayTrigger, Tooltip as RbTooltip } from "react-bootstrap";
import PropTypes from "prop-types";

class Tooltip extends Component {
  static propTypes = {
    text: PropTypes.node.isRequired,
    placement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
    trigger: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    placement: "top",
    trigger: ["hover", "click"]
  };

  renderTooltip() {
    const { placement, text, id, className } = this.props;

    return (
      // <RbTooltip bsClass="rl-tooltip" placement={placement} id={id}>
      <RbTooltip placement={placement} id={id} className={className}>
        {text}
      </RbTooltip>
    );
  }

  render() {
    const { children, placement, trigger } = this.props;
    return (
      <OverlayTrigger
        overlay={this.renderTooltip()}
        trigger={trigger}
        placement={placement}
      >
        {/* span necessary for tooltip to work */}
        <span>{children}</span>
      </OverlayTrigger>
    );
  }
}

export default Tooltip;
